module.exports = __webpack_public_path__ + "img/sport_baseball.fb8c0577.png";